import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import '../styles/color-helpers.css';
import {account_status} from '../constants/status';

// Label source 1: the account status like '已開通', '等待通知中', and so on
const account_statuses = Object.values(account_status)

// Label source 2: the misssion status like '等待', '完成任務' and so on
const statuses = [
    {
        id: 1,
        name: "未執行",
        label: "todo",
        color: 'not-paired-badge text-white',
    },
    {
        "id": 2,
        "name": "委託中",
        "label": "finding",
        color: 'bg-orange-dark text-white'
    },
    {
        "id": 3,
        "name": "已配對",
        "label": "matched",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 4,
        "name": "重新配對中",
        "label": "rematching",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 5,
        "name": "完成",
        "label": "done",
        color: 'bg-green text-white'
    },
    {
        "id": 6,
        "name": "失敗",
        "label": "failed",
        color: 'failed-badge text-white'
    },
    {
        "id": 7,
        "name": "取消",
        "label": "cancelled",
        color: 'cancelled-badge text-black'
    },
    {
        "id": 8,
        "name": "接受",
        "label": "accepted",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 9,
        "name": "拒絕",
        "label": "refused",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 10,
        "name": "通話中",
        "label": "chating",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 11,
        "name": "等待中",
        "label": "waiting",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 12,
        "name": "編輯中",
        "label": "editing",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 13,
        "name": "諮詢室已開",
        "label": "chatRoomReadied",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 14,
        "name": "諮詢室已關",
        "label": "chatRoomClosed",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 15,
        "name": "顧問出發",
        "label": "medicalGo",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 16,
        "name": "顧問抵達",
        "label": "medicalArrived",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 17,
        "name": "延長時間",
        "label": "addTime",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 18,
        "name": "需求變更",
        "label": "demandChange",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 19,
        "name": "完成建議",
        "label": "suggested",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 20,
        "name": "交班完成",
        "label": "reported",
        color: 'bg-blue-darker text-white'
    },
    {
        "id": 21,
        "name": "結束任務",
        "label": "finish",
        color: 'bg-purple-dark text-white'
    },
    {
        "id": 22,
        "name": "其他醫師已接走任務",
        "label": "otherAccepted",
        color: 'bg-blue-darker text-white'
    },

    {
        "id": 28,
        "name": "連絡不到",
        "label": "concernMiss",
        color: 'bg-pink text-white'
    },
    {
        "id": 30,
        "name": "VIP取消",
        "label": "vipCancelled",
        "relate_table": "task",
        color: 'bg-purple text-white'
    },

    {
        "id": 32,
        "name": "指派",
        "label": "assign",
        "relate_table": "task",
        color: 'bg-green text-white'
    },
    {
        "id": 33,
        "name": "預約完成",
        "label": "reserved",
        "relate_table": "task",
        color: 'reserved-badge text-white'
    }
];

// Merging the two label source together to become a big label list
const status_labels = [...account_statuses, ...statuses]

/*
| -------------------------------------------------------------------------
| Component: UecareStatus
| -------------------------------------------------------------------------
| a Badge view of status, different status has a different color background
|
| Arguments:
| name: string, the text showing on the badge
| label: string, the type of badge (it is used to determine bg color)
| -------------------------------------------------------------------------
*/
const UecareStatus = ({name, label}) => {
    // Lookup a pre-defined label from the status labels list with the given label
    const status = _.find(status_labels, {label: label}) || {};

    /*
    Rendering a badge with a specific bg color and the text showing on it
    If the label given is not known, default bg color would be green
    */
    return (
        <div
            className={classNames("inline text-12 p-4 rounded truncate", status.color || 'bg-green text-white')}>
            {name}
        </div>
    );
};

export default UecareStatus



// WEBPACK FOOTER //
// ./src/components/UecareStatus.js